import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Paper,
  List,
  ListItem,
  ListItemText,
  Chip,
  IconButton,
  Button
} from '@mui/material';
import { Check as CheckIcon, Delete as DeleteIcon } from '@mui/icons-material';
import { supabase } from '../../lib/supabase';
import { format } from 'date-fns';

function Alerts() {
  const [alerts, setAlerts] = useState([]);

  useEffect(() => {
    loadAlerts();

    const subscription = supabase
      .channel('alerts_changes')
      .on('postgres_changes', {
        event: '*',
        schema: 'public',
        table: 'alerts'
      }, loadAlerts)
      .subscribe();

    return () => subscription.unsubscribe();
  }, []);

  const loadAlerts = async () => {
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) return;

    const { data } = await supabase
      .from('alerts')
      .select('*')
      .eq('user_id', user.id)
      .order('created_at', { ascending: false });

    setAlerts(data || []);
  };

  const markAsRead = async (id) => {
    await supabase.from('alerts').update({ is_read: true }).eq('id', id);
    loadAlerts();
  };

  const deleteAlert = async (id) => {
    await supabase.from('alerts').delete().eq('id', id);
    loadAlerts();
  };

  return (
    <Box>
      <Typography variant="h4" gutterBottom>Alerts</Typography>
      <Paper>
        <List>
          {alerts.map((alert) => (
            <ListItem key={alert.id} sx={{ opacity: alert.is_read ? 0.6 : 1 }}>
              <ListItemText
                primary={alert.title}
                secondary={
                  <>
                    <Typography component="span" variant="body2">
                      {alert.message}
                    </Typography>
                    <br />
                    <Typography component="span" variant="caption" color="textSecondary">
                      {format(new Date(alert.created_at), 'MMM dd, yyyy HH:mm')}
                    </Typography>
                  </>
                }
              />
              <Chip
                label={alert.severity}
                color={alert.severity === 'critical' ? 'error' : alert.severity === 'warning' ? 'warning' : 'info'}
                size="small"
                sx={{ mr: 1 }}
              />
              {!alert.is_read && (
                <IconButton onClick={() => markAsRead(alert.id)} size="small">
                  <CheckIcon />
                </IconButton>
              )}
              <IconButton onClick={() => deleteAlert(alert.id)} size="small" color="error">
                <DeleteIcon />
              </IconButton>
            </ListItem>
          ))}
          {alerts.length === 0 && (
            <ListItem>
              <ListItemText primary="No alerts" secondary="All clear!" />
            </ListItem>
          )}
        </List>
      </Paper>
    </Box>
  );
}

export default Alerts;
